import { PageType } from '@app/config';

const SCREENS = {
  AMOUNT_ENTRY: 'Amount Entry',
  ACCOUNT_DEBUG_MENU: 'Account Debug Menu',
  ACCOUNT_SECURITY: 'Account Security',
  ACCOUNT_PROFILE: 'Account Profile',
  ACCOUNT_PORTFOLIO: 'Account Portfolio',
  ACCOUNT_FOLLOWING: 'Account Following',
  ACCOUNT_FAVORITES: 'Account Favorites',
  ACCOUNT_SETTING: 'Account Setting',
  ACCOUNT_MESSAGE_CENTER: 'Account Message Center',
  AS_SEEN_ON_INSTAGRAM: 'As Seen on Instagram',
  BILLING: 'Billing',
  BROWSE: PageType.Browse,
  CONFIRMATION: 'Confirmation',
  CHECKOUT_FLOW: 'Checkout flow',
  FOLLOWING: PageType.Following,
  HOME: PageType.Home,
  PORTFOLIO: PageType.Portfolio,
  PRODUCT: PageType.Product,
  RELEASE: PageType.Release,
  REVIEW: 'Review',
  SEARCH: PageType.Search,
  SELLING: PageType.Selling,
  SELL_FLOW: 'Sell Flow',
  SIZE_SELECTOR: 'Size Selector',
  SETTINGS: 'Settings',
  VIEW_ALL: 'View All',
  DOPPELGANGER: PageType.Doppelganger,
  QUERY_SUGGESTION: 'Query Suggestions',
  NFT_NEWS_SIGNUP: 'NFT News Signup Confirmation',
  ACCOUNT: 'Account',
  REDEEM_REVIEW: 'Redeem Review',
  REDEEM_CONFIRMATION: 'Confirmation',
  HTML_SITEMAP: 'HTML Sitemap',
  SELL_HOW_IT_WORKS: 'How It Works',
  SINGLE_PAGE_CHK: 'Single Page CHK',
  SHIPPING: 'Shipping Address',
  SUGGESTED_ADDRESS: 'Suggested Address',
  EXTENDED_SHIPPING: 'Extended Shipping',
  SELLER_SHIPPING_EXTENSION_PENDING_SHIPPING: 'PendingShipping',
  SELLER_SHIPPING_EXTENSION_PRODUCT_DETAILS: 'ProductDetails',
  UNAUTHENTICATED_CHECKOUT: 'Unauthenticated Checkout flow',
  UNAUTHENTICATED_SELL_FLOW: 'Unauthenticated Sell flow',
  PAYMENT: 'Payment',
  PAYMENT_FORM: 'Payment Form',
  BNPL_FLOW: 'BNPL Flow',
  SELLER_SETTINGS: 'Seller Settings',
  BUYER_SETTINGS: 'Buyer Settings',
};

export default SCREENS;
